/* eslint-disable simple-import-sort/imports */
import { initSentry } from "./instrumentation";
import * as Sentry from "@sentry/react";

import { Capacitor } from "@capacitor/core";
import { RouterProvider } from "react-router-dom";
import { createRoot } from "react-dom/client";

import { router } from "./router";
import { initCapacitorPlugins } from "./util/capacitorInit";

import "./global.css";

const root = document.getElementById("root")!;

initCapacitorPlugins();

if (window.location.pathname === "/" && !Capacitor.isNativePlatform()) {
  window.location.replace("/app");
} else {
  // Initialize Sentry for error tracking and performance monitoring
  initSentry();

  createRoot(root, {
    // Callback called when an error is thrown and not caught by an ErrorBoundary.
    onUncaughtError: Sentry.reactErrorHandler((error, errorInfo) => {
      console.warn("Uncaught error", error, errorInfo.componentStack);
    }),
    // Callback called when React catches an error in an ErrorBoundary.
    onCaughtError: Sentry.reactErrorHandler(),
    // Callback called when React automatically recovers from errors.
    onRecoverableError: Sentry.reactErrorHandler(),
  }).render(<RouterProvider router={router} />);
}
